module.exports = {
    FAVORITE_PROGRAM_ADD: 'FAVORITE_PROGRAM_ADD',
    FAVORITE_PROGRAM_DEL: 'FAVORITE_PROGRAM_DEL',
    FAVORITE_PROGRAM_ADD_SESSION: 'FAVORITE_PROGRAM_ADD_SESSION',
    FAVORITE_PROGRAM_DEL_SESSION: 'FAVORITE_PROGRAM_DEL_SESSION',
    FAVORITE_PROGRAMS_UPDATED: 'FAVORITE_PROGRAMS_UPDATED',
    FAVORITE_PROGRAMS_UPDATED_EXTERNAL: 'FAVORITE_PROGRAMS_UPDATED_EXTERNAL',
};
